var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 568,
    height: 449,
    viewBox: "0 0 568 449",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408 256H312.9C295.23 256 280.9 270.33 280.9 288C280.9 305.67 295.23 320 312.9 320H408C425.67 320 440 305.67 440 288C440 270.33 425.7 256 408 256ZM536 0H312.9C295.23 0 280.9 14.33 280.9 32C280.9 49.67 295.23 64 312.9 64H536C553.67 64 568 49.67 568 32C568 14.33 553.7 0 536 0ZM344 384H312C294.33 384 280 398.33 280 416C280 433.67 294.33 448 312 448H344C361.67 448 375.1 433.67 375.1 416C375.1 398.33 361.7 384 344 384ZM472 128H312.9C295.23 128 280.9 142.33 280.9 160C280.9 177.67 295.23 192 312.9 192H472C489.67 192 504 177.67 504 160C504 142.33 489.7 128 472 128ZM184.4 298.7L152 334.1V32.03C152 14.33 137.7 0 120 0C102.3 0 88 14.33 88 32.03V334.03L55.6 298.7C49.288 291.817 40.66 288.32 31.99 288.32C24.271 288.32 16.52 291.101 10.38 296.734C-2.64999 308.684 -3.51999 328.954 8.41101 342.004L95.511 438.094C107.631 451.354 130.571 451.354 142.701 438.094L229.801 342.004C241.741 328.954 240.861 308.694 227.832 296.734C216.6 284.8 196.4 285.7 184.4 298.7Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.f7eed503917824350fdcf6b28cdbdae7.svg";
export { ForwardRef as ReactComponent };